import React from "react";
import '@abb/abb-common-ux-react/styles.css';
import "./shared.sass";
import { ISidebarDetail } from "../../models/shared/SidebarDetail";
import { Input, Tooltip, WithTooltip,  Spinner } from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { Status } from "../../models/sample/Status";
import InfiniteScroll from 'react-infinite-scroll-component';

interface ISidebarListProperties {
    activeId: string;
    onSelectLink: (id: string) => any;
    listData: ISidebarDetail[];
    isShowBackup?: boolean;
    isAutoBackup?: boolean;
    onAutoBackupClick?: (val: boolean) => any;
    setBackupPrefix?: (val: string) => void;
    backupPrefix?: any;
    prefixError?: boolean;
    fetchData?: () => any;
    fetchMore?: () => any;
    hasMore?: boolean;
    module?: string;
    listRef?: any;
}

class SidebarList extends React.Component<ISidebarListProperties> {
    public render() {
        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            <ul  ref={this.props.listRef} id="scrollableDiv" style={{ overflow: 'auto', height: "100%" }} className={`${this.props.isShowBackup ? "sidebar-list-layout overflow-auto mt-2" : "sidebar-nav-ul sidebar-list-layout overflow-auto mt-2"}`}>

                                <InfiniteScroll
                                    dataLength={this.props.listData.length} //This is important field to render the next data
                                    next={this.props.fetchMore}
                                    hasMore={this.props.hasMore}
                                    loader={<div><h6 style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center' }}><Spinner color='blue' sizeClass='medium' /></h6><div></div></div>}
                                    scrollThreshold={0.6}
                                    scrollableTarget="scrollableDiv"
                                >
                                    {this.props.listData.length > 0 ? (this.props.listData || []).map((d, key) => {
                                        return (
                                            <li key={key}
                                                onClick={() => this.props.onSelectLink(d.id)}
                                                className={`${this.props.activeId === d.id ? "active-link tooltip-bottom" : "tooltip-bottom" }
                                                 ${d.status === Status.MEASURING || d.status === Status.STOPPED || d.status === Status.PAUSED ? "measuredState" : d.status === Status.APPROVED ? "approvedState" : d.status === Status.REJECTED ? "rejectedState" : d.status === Status.MEASURED ? "completedState" : null}
                                                 ${this.props.module === t(CONSTANTS.MODULE_SAMPLE) ? "non-active-link" : null}`} data-tooltip={d.name}>
                                                <div className="sidebar-items p-1 mb-0">
                                                    <WithTooltip>
                                                        <span className="text-ellipsis width-11rem">{d.name}</span>
                                                        <Tooltip>
                                                            {d.name}
                                                        </Tooltip>
                                                    </WithTooltip>
                                                </div>
                                            </li>
                                        )
                                    })
                                        :

                                        this.props.isShowBackup ?
                                            <div>
                                                <div className="row-backup">
                                                    <div className="col-sm col-md col-backup">
                                                        <Input
                                                            dataType="text"
                                                            placeholder={t(CONSTANTS.LABEL_PREFIX)}
                                                            label={t(CONSTANTS.LABEL_PREFIX)}
                                                            className={this.props.prefixError ? "error-code mt-2" : "mt-2"}
                                                            maxLength={20}
                                                            value={String(this.props.backupPrefix)}
                                                            onValueChange={(val: string) => this.props.setBackupPrefix(val)}
                                                            showValidationBarWhenInvalid={this.props.prefixError}
                                                            description={this.props.prefixError && t(CONSTANTS.NAME_VALIDATION_ERROR)}
                                                        />
                                                    </div>
                                                </div>


                                            </div> :

                                            <div className="px-5"><b>{t(CONSTANTS.NO_DATA_MESSAGE)}</b></div>
                                    }
                                </InfiniteScroll>
                            </ul>
                        </React.Fragment>

                }
            </Translation>
        );
    }
}

export default SidebarList;
